// src/components/EventCardSkeleton.jsx
import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css"; 

const EventCardSkeleton = () => {
  return (
    <div className="event-card">
      {/* Image placeholder */}
      <Skeleton height={140} />

      <div className="event-card__details" style={{ marginTop: 12 }}>
        {/* Title */}
        <Skeleton width="60%" />
        {/* Description */}
        <Skeleton width="80%" />
      </div>
    </div>
  );
};

export default EventCardSkeleton;
